import React, { useState, useEffect } from "react";
import { useMachine } from "../../context/MachineContext";
import {Container, Row, Col, Card, CardBody, CardTitle, Button, CardHeader, CardFooter,} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
const MachineSelection = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [machines, setMachines] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
 const { setSelectedMachineId } = useMachine();
  const authToken = localStorage.getItem("access");
  const company = localStorage.getItem("companyid");
  const companyId = localStorage.getItem("companyid");

  const fetchMachines = async () => {
    try {
      setIsLoading(true)
      const response = await axios.get(`https://api.hanoch.in/api/machines/by-company/?id=${company}`);
    setMachines(response);
    console.log("id",response)
      } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      }
       else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };
    useEffect(() => {
    fetchMachines();
  }, []);

  //  const handleMachineClick = (id) => {
  //   setSelectedMachineId(id);
  //   localStorage.setItem('selectedMachineId',id);
  //   navigate("/dashboard", { state: {id} })
  // };

  const handleMachineClick = (id) => {
  
   setSelectedMachineId(id);
   localStorage.setItem('selectedMachineId',id);
  if (!companyId) {
    console.error("Company ID not found in localStorage");
    return;
  }

  if (companyId == 6) {
    navigate("/temperatureTrend", { state: {id} });
  } else {
    navigate("/dashboard", { state: {id} })
  };
  }

  document.title = "Overview | OptiMize ";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Overview" />
          <Row>
            <Col xl={4} sm={6}>
              <Card >
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-shrink-0 me-3 align-self-center">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light rounded-circle text-primary" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="ri-time-line"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1">Machines</p>
                      <h5 className="mb-3">{machines?.total_machines}</h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={4} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3 align-self-center">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light rounded-circle text-success" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="ri-checkbox-circle-line"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1">Active</p>
                      <h5 className="mb-3">
                        {machines?.active_count}  
                        </h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={4} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-shrink-0 me-3 align-self-center">
                      {/* Replace RadialChart with icon */}
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light rounded-circle text-danger" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="ri-close-circle-line"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1">Inactive</p>
                      {/* <h5 className="mb-3">{machines?.data?.length-machines?.running?.length} </h5> */}
                      <h5 className="mb-3">
                        {machines?.inactive_count}
                        </h5>
                      {/* Commented section remains the same */}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* <Col xl={3} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex text-muted">
                    <div className="flex-shrink-0 me-3 align-self-center">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light rounded-circle text-primary" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="ri-group-line"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1">Work Order</p>
                      <h5 className="mb-3">{machines?.running?.length}</h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col> */}
          </Row>

          {isLoading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (

            <Row>
              <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "5px",
  }}
>
              {machines?.data?.sort((a, b) => (b.is_running === true) - (a.is_running === true))
  .map((machine, index) => (
                
                  <Card
                    onClick={() => handleMachineClick(machine.id) }
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    style={{
                      cursor: "pointer",
                      transform: hoveredIndex === index ? "translateY(-3px)" : "none",
                      boxShadow:
                        hoveredIndex === index
                          ? "0 4px 12px rgba(0, 0, 0, 0.15)"
                          : "none",
                      border:
                        hoveredIndex === index ? "1px solidrgb(20, 33, 60)" : "1px solid transparent",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease, border 0.2s ease",
                    }}>
                    <CardHeader>
                      <div className="d-flex justify-content-between align-items-center ">
<span>
 <h6><b> {machine?.name}</b></h6>

</span>
                        <div className="blinking-text">
                          <img
                            width="14"
                            height="14"
                            src={
                              machine?.machine_status === "running"
                                ? "https://img.icons8.com/ios-filled/50/40C057/filled-circle.png"
                                // :"https://img.icons8.com/ios-filled/50/40C057/filled-circle.png"
                                : "https://img.icons8.com/ios-filled/50/FA5252/filled-circle.png"
                            }

                          />
                        </div>
                      </div>

                    </CardHeader>
                    <CardBody>
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="justify-content-center align-items-center">
                          <img src={`https://api.hanoch.in/media/${machine.image}`} alt="machine" height="50" className="align-items-center img-fluid" />

                        </div>
                      </div>
                    </CardBody>
                    <CardFooter>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <p className="mb-1">Temperature</p>
                          <h6 className="mb-0">{machine?.temperature}°C</h6>
                        </div>
                      <div>{machine?.last_seen}</div>
                        </div>
                    </CardFooter>
                  </Card>
                 
              ))}
 </div>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MachineSelection;
